const fontFamily = {
  poppins: ['var(--font-poppins)']
}

export { fontFamily }
